import { useState } from 'react'
import { useContextBoard } from '../hooks'
import type { TaskContext } from '../types'
import { CreateTaskDialog } from './CreateTaskDialog'
import { KanbanBoard } from './KanbanBoard'

type Props = {
  contractId: number
  /** Etykieta kontekstu - numer umowy + zamawiający. */
  contractLabel: string
}

/**
 * Zakładka "Zadania" na ContractDetailPage. Faza 2B: zamiast prostej listy
 * embed kanban context board dla tej umowy.
 *
 * Frontend dostarcza `label` przy pierwszym wejściu - backend snapshotuje go do
 * tworzenia boardu kontekstowego. Kolejne wejścia używają wartości już zapisanej.
 */
export function ContractTasksTab({ contractId, contractLabel }: Props) {
  const board = useContextBoard({
    system: 'EASY',
    type: 'CONTRACT',
    id: contractId,
    label: contractLabel,
  })
  const [creating, setCreating] = useState(false)

  const context: TaskContext = {
    system: 'EASY',
    type: 'CONTRACT',
    id: contractId,
    label: contractLabel,
  }

  return (
    <div className="flex flex-col h-[600px]">
      <div className="flex items-center justify-between px-4 py-2 border-b border-slate-200">
        <h3 className="text-sm font-semibold">Zadania umowy</h3>
        <button
          onClick={() => setCreating(true)}
          className="text-xs bg-sky-600 text-white rounded px-2 py-1"
        >
          + Nowe zadanie
        </button>
      </div>
      <div className="flex-1 min-h-0">
        {board.isLoading && (
          <p className="text-xs text-slate-400 italic p-4">Ładowanie boardu…</p>
        )}
        {board.isError && (
          <p className="text-xs text-red-600 p-4">Nie udało się załadować boardu.</p>
        )}
        {board.data && <KanbanBoard board={board.data} />}
      </div>

      {creating && <CreateTaskDialog context={context} onClose={() => setCreating(false)} />}
    </div>
  )
}
